import UploadFileToFolder from '@/components/common/UploadFileToFolder';
import RpuUploadForm from '@/components/Ingestions/RpuUploadForm';
import { useOidc } from '@/shared/auth/oidc';
import { useTranslate } from '@tolgee/react';

const RPU_IMPORT_FOLDER_ID: string = import.meta.env.VITE_DIRECTUS_RPU_UPLOAD_FOLDER;

/** Bouton d'import manuel d'un fichier RPU dans le dossier de dépôt Directus. */
const RpuUploadButton = () => {
  const { t } = useTranslate();
  const oidc = useOidc();

  // Lu ici : le contenu de la modale est rendu hors du contexte OIDC.
  if (!oidc.isUserLoggedIn) {
    return null;
  }

  const userId = oidc.decodedIdToken.sub;

  return (
    <UploadFileToFolder
      folder={RPU_IMPORT_FOLDER_ID}
      permissionIds={['deposit-rpu-files']}
      label={t('admin.ingestions.import.title')}
      modalSize="lg"
      renderContent={upload => <RpuUploadForm userId={userId} onUpload={upload} />}
    />
  );
};

export default RpuUploadButton;
